export default "__VITE_ASSET__BHJjopcz__"